export const DEFAULT_MAX_NUMBER_OF_LOCATIONS = 3;
export const JOB_DETAILS_VIEW_MAX_NUMBER_OF_LOCATIONS = 2;
export const DEFAULT_LOCATION_LABEL_CHARACTER_LIMIT = undefined;
export const JOB_DETAILS_VIEW_LOCATION_LABEL_CHARACTER_LIMIT = 25;
